module.exports = __webpack_public_path__ + "static/01_corezoid-visa-privatbank-teams-e0f7f755f2030bff16d9258e1206d4f1.webp";